import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="bg-secondary text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <h2 className="text-2xl font-bold mb-4">
              <span className="text-primary">Stack</span>Studio
            </h2>
            <p className="text-gray-300 mb-6 max-w-md">
              Fullstack developer specializing in React.js, Next.js, and ASP.NET Web API, 
              bringing creative solutions to complex problems.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="social-icon text-gray-300 hover:text-primary">
                <i className="fab fa-github text-xl"></i>
              </a>
              <a href="#" className="social-icon text-gray-300 hover:text-primary">
                <i className="fab fa-linkedin-in text-xl"></i>
              </a>
              <a href="#" className="social-icon text-gray-300 hover:text-primary">
                <i className="fab fa-twitter text-xl"></i>
              </a>
              <a href="#" className="social-icon text-gray-300 hover:text-primary">
                <i className="fab fa-dev text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4 relative pb-2">
              <span className="after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-1 after:w-10 after:bg-primary">
                Quick Links
              </span>
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-gray-300 hover:text-primary transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-300 hover:text-primary transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-gray-300 hover:text-primary transition-colors">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-primary transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-300 hover:text-primary transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4 relative pb-2">
              <span className="after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-1 after:w-10 after:bg-primary">
                Contact Info
              </span>
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="fas fa-envelope text-primary mt-1 mr-3"></i>
                <a href="mailto:iamzee4@gmail.com" className="text-gray-300 hover:text-primary transition-colors">
                  iamzee4@gmail.com
                </a>
              </li>
              <li className="flex items-start">
                <i className="fas fa-phone text-primary mt-1 mr-3"></i>
                <a href="tel:+923361055952" className="text-gray-300 hover:text-primary transition-colors">
                  +92 (336) 105-5952
                </a>
              </li>
              <li className="flex items-start">
                <i className="fas fa-map-marker-alt text-primary mt-1 mr-3"></i>
                <span className="text-gray-300">
                  Islamabad, Pakistan
                </span>
              </li>
            </ul>
          </div>
        </div>
        
        <hr className="my-8 border-gray-700" />
        
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            &copy; {currentYear} Zeeshan Mehboob. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="mt-4 md:mt-0 bg-primary hover:bg-blue-600 text-white rounded-full w-10 h-10 flex items-center justify-center transition-colors"
          >
            <i className="fas fa-arrow-up"></i>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;